import { useCallback } from 'react';
import { useAppInitStore } from '../../stores';

export const useUploadedDocumentConfigs = () => {
	const uploadedDocumentConfigs = useAppInitStore((s) => s.uploadedDocumentConfigs);

	const getUploadedDocumentConfigByType = useCallback(
		(type: number) => uploadedDocumentConfigs?.find((d) => +d.uploadedDocumentType == type),
		[uploadedDocumentConfigs]
	);

	return { uploadedDocumentConfigs, getUploadedDocumentConfigByType };
};
